<template>
    <div class="root_page_center wrapper_linkaccount">
        <div class="row titleMenu">
            Thông tin tài khoản
        </div>
        <div class="session1">
            <div class="imgUserHome">
                <img src="../assets/images/account.png" alt="" v-if="listInfo.portrait == null">
                <img :src="linkWebAdmin + listInfo.portrait" alt="" v-else>
            </div>
            <div class="infoHome" style="color: #000;">
                <p class="p_balance_ed">Số dư</p>
                <h2>{{ new Intl.NumberFormat('vi-VN', { minimumFractionDigits: 0 }).format(balance)}} vnđ</h2>
                <h5 class="txt_num_bank" v-if="banknumber != null">STK: {{ banknumber }}</h5>
                <h5 class="txt_num_bank" v-if="bank_name != null">Ngân hàng: {{ bank_name }}</h5>
                <p class="title_addTxt">Ngân hàng hoàn thuế</p>
            </div>
        </div>
        <div class="btn_show_noti_txt">
            <button @click="showModal=true">Hoàn thuế</button>
        </div>
        <div class="modalRedirect" v-if="showModal">
            <div class="content_modalredirect content_modalredirectHds">
                <p @click="showModal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showModal = false" alt=""></p>
                <h3>Quý khách vui lòng hoàn thành thủ tục kê khai để hoàn thuế</h3>
            </div>
        </div>
        <!-- <div class="wp_accountbank">
            <h3 class="title_dxcao">Đề xuất cao</h3>
            <div class="row">
                <div class="wp-accountbank--border" v-if="listBank && listBank.length">
                    <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank" :key="index">
                        <div class="itemBank">
                            <img :src="linkWebAdmin + item.image" alt="" @click="showMd(index)">
                            <img src="../assets/images/st.png" alt="" class="iconstar">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-4 wp_itemBank" v-for="(item, index) in listBank1" :key="index">
                    <div class="itemBank">
                        <img :src="linkWebAdmin + item.image" alt="" @click="showMds()">
                    </div>
                </div>

            </div>
            <div class="modalRedirect" v-if="showmodal">
                <div class="content_modalredirect">
                    <p @click="showmodal = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodal = false" alt=""></p>
                    <h3>Vui lòng cập nhật ứng dụng lên phiên bản mới nhất</h3>
                    <router-link to="/bank-update">
                        <button type="button">Cập nhật ngay</button>
                    </router-link>
                    <router-link to="/bank" class="linkshortcut">&nbsp;</router-link>
                    <p class="linkshortcutModal" @click="hideModalClick()">&nbsp;</p>
                </div>
            </div>
            <div class="modalRedirect" v-if="showmodals">
                <div class="content_modalredirect">
                    <p @click="showmodals = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodals = false" alt=""></p>
                    <h3 class="mg_bt_zr">Hiện tại ngân hàng đang bảo trì hệ thống sinh trác học. Vui lòng chọn ngân hàng khác để kê khai</h3>
                </div>
            </div>
            <div class="modalRedirect" v-if="showmodalUpdate">
                <div class="content_modalredirect">
                    <p @click="showmodalUpdate = false" class="closeMdredirect"><img src="../assets/images/close.png" @click="showmodalUpdate = false" alt=""></p>
                    <h3 class="textBalance">Cập nhật số dư</h3>
                    <form action="" method="post" @submit="sendMoneyUpdate($event)">
                        <div class="inputUpdate">
                            <input type="text" v-model="showBalance" @input="onNumberInput">
                        </div>
                        <div class="inputUpdate">
                            <button>Cập nhật</button>
                        </div>
                    </form>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'Linkaccount_tool',
    data() {
        return {
            token: window.localStorage.getItem('token'),
            // listBank: [],
            // listBank1: [],
            // showmodal: false,
            // showmodals: false,
            // itemBank: [],
            // showmodalUpdate: false,
            // showBalance: '',
            listInfo: [],
            balance: 0,
            showModal: false,
            banknumber: '',
            bank_name: ''
        }
    },
    components: {

    },
    mounted() {

    },
    created() {
        // this.getListBank()
        // this.getListBank1()
        this.getDataInfoST()
        this.getDataListInfo()
    },
    computed: {

    },
    beforeUnmount() {

    },
    methods: {
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.listInfo = response.data.data
                this.balance = response.data.data.bank_balance
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataInfoST () {
            this.axios.get(this.api_getBusiness,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                if(response.data.data != null){
                    this.banknumber = response.data.data.bank_account_number
                    this.bank_name = response.data.data.bank_name_text
                }
            })
        },
        getListBank() {
            this.axios.get(this.api_logoBanks + '?status=1').then((response) => {
                this.listBank = response.data.data
            }).catch(e => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getListBank1() {
            this.axios.get(this.api_logoBanks + '?status=0').then((response) => {
                this.listBank1 = response.data.data
            })
        },
        showMd(index) {
            this.showmodal = true
            this.itemBank = this.listBank[index]
            window.localStorage.setItem('nameBank', this.itemBank.name)
            window.localStorage.setItem('title', this.itemBank.blue_text)
            window.localStorage.setItem('icon', this.itemBank.logo)
            window.localStorage.setItem('idbank', this.itemBank.id)
        },
        showMds() {
            this.showmodals = true
        },
        hideModalClick () {
            this.showmodal = false
            this.showmodalUpdate = true
            this.getDataBankOld()
        },
        getDataBankOld () {
            let idBank = window.localStorage.getItem('idbank')
            this.axios.get(this.api_bankMoney + '?bank_id=' + idBank,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.showBalance = Number(response.data.data.money).toLocaleString('vi-VN')
                this.balance = response.data.data.money
            })
        },
        onNumberInput(e) {
            // const raw = e.target.value.replace(/,/g, '');
            const raw = e.target.value.replace(/\./g, '');
            this.balance = raw
            this.showBalance = this.formatNumber(raw);
        },
        formatNumber(value) {
            const cleaned = value.split('.')[0];
            const num = cleaned.replace(/\D/g, '');
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        sendMoneyUpdate (e) {
            e.preventDefault()
            $('#loadingImg').show().fadeIn(10)
            this.axios.post(this.api_updateMoney, 
                {
                    bank_id: window.localStorage.getItem('idbank'),
                    balance: this.balance,
                    user_id: window.localStorage.getItem('idUser')
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingImg').css('display', 'none')
                // this.showmodalUpdate = false
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            }).catch(e => {
                $('#loadingImg').css('display', 'none')
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        }
    }
}
</script>